import "./App.css";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import Home from "./components/Pages/Home/Home";
import Header from "./components/Layout/Header/Header";
import Footer from "./components/Layout/Footer/Footer";
import Equipement from "./components/Pages/Equipement/Equipement";
import Accesoires from "./components/Pages/Accesoires/Accesoires";
import About from "./components/Pages/About/About";
import Contact from "./components/Pages/Contact/Contact";
import ErrorNotFound from "./components/Pages/ErrorNotFound/ErrorNotFound";

import "react-toastify/dist/ReactToastify.css";
import "./assets/sass/style.scss";
import Scrollbar from "./components/Shared/Scrollbar/Scrollbar";
import ProductDetails from "./components/Pages/ProductDetails/ProductDetails";
import ProductList from "./components/Pages/ProductList/ProductList";
import BTP from "./components/Pages/others/BTP/BTP";
import Nettoyage from "./components/Pages/others/Nettoyage/Nettoyage";
import { EquipementData } from "./api/EquipementData";
import { NetoyageData } from "./api/NetoyagaData";
import { BtpData } from "./api/BtpData";
import OtherDetails from "./components/Pages/others/OtherDetails/OtherDetails";
import HomeOthers from "./components/Pages/others/HomeOthers/HomeOthers";
import OtherAccesoires from "./components/Pages/others/OtherAccesoires/OtherAccesoires";

// import ScrollToTopRender from "./Components/Shared/ScrollToTop_render";

function App() {
  return (
    <>
      <Router>
        {/* <ScrollToTopRender /> */}
        <Header />
        <Routes>
          <Route exact path="/" element={<Home />} />
          <Route exact path="/others/" element={<HomeOthers />} />
          <Route exact path="equipement" element={<Equipement />} />
          <Route
            exact
            path="/equipement/single/:id"
            element={
              <ProductList
                data={EquipementData}
                title="Equipement"
                currentPage="Equipement"
                link="equipement"
                subTitle="GEHL"
                route="/equipement"
              />
            }
          />{" "}
          <Route
            exact
            path="/equipement/:selectedEquipmentId/details/:productId"
            element={<ProductDetails />}
          />
          <Route
            exact
            path="accesoires/:accesoireId"
            element={<Accesoires />}
          />
          <Route
            exact
            path="/others/autre_accesoires/:accesoireId"
            element={<OtherAccesoires />}
          />
          <Route exact path="about" element={<About />} />
          <Route exact path="/others/about" element={<About />} />
          <Route exact path="contact" element={<Contact />} />
          <Route exact path="/others/contact" element={<Contact />} />
          {/* others */}
          <Route exact path="/others/btp" element={<BTP />} />
          <Route
            exact
            path="/others/btp/single/:id"
            element={
              <ProductList
                data={BtpData}
                title="BTP"
                currentPage="BTP"
                link="others/btp"
                route="/others/btp"
              />
            }
          />
          <Route
            exact
            path="/others/btp/:selectedId/details/:productId"
            element={
              <OtherDetails
                data={BtpData}
                title="BTP"
                currentPage="BTP"
                link="others/btp"
              />
            }
          />
          <Route exact path="/others/nettoyage" element={<Nettoyage />} />
          <Route
            exact
            path="/others/nettoyage/single/:id"
            element={
              <ProductList
                data={NetoyageData}
                title="Nettoyage"
                currentPage="Nettoyage"
                link="others/nettoyage"
                route="/others/nettoyage"
              />
            }
          />
          <Route
            exact
            path="/others/nettoyage/:selectedId/details/:productId"
            element={
              <OtherDetails
                data={NetoyageData}
                title="Nettoyage"
                currentPage="Nettoyage"
                link="others/nettoyage"
              />
            }
          />
          <Route path="*" element={<ErrorNotFound />} />
        </Routes>
        <Footer />
        <Scrollbar />
      </Router>
    </>
  );
}

export default App;
